import Node from './Node';

export default class ListItem extends Node {
  constructor(bullet, segments) {
    super();
    this.bullet = bullet;
    this.segments = segments;
  }

  finalize(root, parent) {
    super.finalize(root, parent);
    this.segments.forEach((s) => s.finalize(root, this));
    this.root.emojiOnly = false;
  }

  toJSON() {
    return {
      type: this.bullet.type,
      index: this.bullet.index,
      bullet: this.bullet,
      segments: this.segments.map((s) => s.toJSON()),
    };
  }

  toSource() {
    return [this.bullet.text, ...this.segments.map((s) => s.toSource())].join('');
  }
}
